import NameModal from '../Chat/NameModal';
import Button from '../common/Button';
import MinimalFooter from '../common/MinimalFooter';
import MinimalHeader from '../common/MinimalHeader';
import AdvisorBadge from './AdvisorBadge';
import ConsentAccordionSection from './ConsentAccordionSection';
import ContactCard from './ContactCard';
import type { ConsentProps } from './useConsent';
import WarningSection from './WarningSection';

const ConsentDesktop = ({
  data,
  accordion1Open,
  accordion2Open,
  toggleAccordion1,
  toggleAccordion2,
  handleAccept,
  handleRefuse,
  canAccept,
  showNameModal,
  handleNameSubmit,
  handleCloseNameModal,
}: ConsentProps) => {
  return (
    <div className="flex min-h-screen flex-col bg-surface-primary">
      <MinimalHeader />

      <main className="flex flex-1 justify-center px-20 py-10 pb-15">
        <div className="flex w-full max-w-[800px] flex-col gap-7 rounded-2xl bg-surface-card p-10 px-12 shadow-lg">
          <AdvisorBadge text={data.advisorBadge} variant="desktop" />

          <div className="flex flex-col gap-3">
            <h1 className="font-heading text-2xl font-semibold text-foreground-primary">
              {data.title}
            </h1>
            <p className="font-body text-[15px] leading-[1.5] text-foreground-secondary">
              {data.subtitle}
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <ConsentAccordionSection
              data={data.accordion1}
              isOpen={accordion1Open}
              onToggle={toggleAccordion1}
              variant="desktop"
            />
            <ConsentAccordionSection
              data={data.accordion2}
              isOpen={accordion2Open}
              onToggle={toggleAccordion2}
              variant="desktop"
            />
          </div>

          <ContactCard
            label={data.contact.label}
            name={data.contact.name}
            email={data.contact.email}
            phone={data.contact.phone}
          />

          <WarningSection
            title={data.warning.title}
            description={data.warning.description}
            variant="desktop"
          />

          <div className="flex gap-4">
            <div className="group relative flex-1">
              <Button
                variant="solid"
                size="lg"
                onClick={handleAccept}
                disabled={!canAccept}
                className="w-full rounded-[10px] py-4"
              >
                {data.buttons.accept}
              </Button>
              {!canAccept && (
                <div className="pointer-events-none absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap rounded-lg bg-foreground-primary px-3 py-2 text-sm text-surface-primary opacity-0 shadow-lg transition-opacity group-hover:opacity-100">
                  {data.buttons.disabledHint}
                  <div className="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-foreground-primary" />
                </div>
              )}
            </div>
            <Button
              variant="secondary"
              size="lg"
              onClick={handleRefuse}
              className="flex-1 rounded-[10px] py-4 font-medium"
            >
              {data.buttons.refuse}
            </Button>
          </div>
        </div>
      </main>

      <MinimalFooter variant="desktop" />

      {showNameModal && (
        <NameModal onSubmit={handleNameSubmit} onClose={handleCloseNameModal} />
      )}
    </div>
  );
};

export default ConsentDesktop;
